import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import { getStore } from '../../store/store';
import { startInterdiction, workingEnd } from 'wfui-digital-core/es/actions';
import { NAVIGATION_NAVIGATE } from '../../../lib/store/navigation/actions';
import getJson from '../../../lib/network/get-json';
import logger from '../../logger/logger';

var fetchSamlDetails = function fetchSamlDetails(navigation) {
  var _navigation$navigatio = navigation.navigationItem,
      navigationItem = _navigation$navigatio === void 0 ? {} : _navigation$navigatio;

  if (navigationItem.url) {
    logger.debug('SAML: Fetching SAML info', navigationItem.url);
    return new Promise(function (resolve, reject) {
      getJson({
        url: navigationItem.url,
        includeRootContext: false,
        params: navigationItem.requestParams
      }).then(function (result) {
        if (result.samlTransferViewBean && result.samlTransferViewBean.samlOutInfo) {
          logger.debug('SAML: Received SAML info');
          logger.debug("SAML: ".concat(result.samlTransferViewBean.samlOutInfo.destinationUrl));
          navigation.samlDetails = result.samlTransferViewBean.samlOutInfo;
          resolve(navigation);
        } else {
          navigation.failureReason = 'Response did not contain samlOutInfo';
          reject(navigation);
        }
      }, function (result) {
        if (result.hasOwnProperty('interdictionViewBean')) {
          result.InterdictionViewBean = result.interdictionViewBean;
          delete result.interdictionViewBean;
        }

        var _result$InterdictionV = result.InterdictionViewBean,
            InterdictionViewBean = _result$InterdictionV === void 0 ? {} : _result$InterdictionV;

        if (InterdictionViewBean.authenticationViewBeans || InterdictionViewBean.authenticationViewBean) {
          navigation.interdictionRequested = true;
          getStore().dispatch(workingEnd());
          getStore().dispatch(startInterdiction({
            interdiction: InterdictionViewBean,
            postSuccessAction: NAVIGATION_NAVIGATE
          }));
          reject(navigation);
        } else if (navigationItem.auth && navigationItem.auth.state() === 'rejected') {
          logger.debug('Authorization rejected; force:', navigationItem.force);

          if (!navigationItem.force) {
            logger.debug('Authorization rejected');
          } else {
            delete navigationItem.force;
          }

          navigation.failureReason = 'Navigation fetch failed';
          reject(navigation);
        }
      });
    });
  } else if (navigationItem.fragment) {
    navigation.failureReason = 'Fragment navigation not supported';
    return Promise.reject(navigation);
  } else if (navigationItem.contentId) {
    navigation.failureReason = 'Content navigation not supported';
    return Promise.reject(navigation);
  } else {
    navigation.failureReason = 'Invalid options object';
    return Promise.reject(navigation);
  }
};

export default fetchSamlDetails;